import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FAQ_ITEMS } from './landingData';

// NOTE: The FAQPage JSON-LD lives in public/index.html (static so non-JS
// LLM crawlers can parse it). The questions/answers here MUST stay in sync
// with that static schema — both feed off the same FAQ_ITEMS array, so as
// long as you only edit landingData.ts, they stay aligned.
export function FaqSection() {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  return (
    <section className="py-20 px-6 sm:px-8" id="faq">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#a8abb3] font-bold block mb-4">FAQ</span>
          <h2 className="text-3xl sm:text-4xl font-headline font-bold tracking-tighter text-[#f1f3fc]">
            Frequently Asked<br /><span className="text-[#a8abb3]">Questions</span>
          </h2>
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((faq, index) => (
            <div
              key={index}
              className="bg-[#1b2028] border border-[#44484f]/10 rounded-2xl overflow-hidden hover:border-[#44484f]/30 transition-all"
            >
              <button
                onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left"
              >
                <span className="text-[#f1f3fc] font-medium pr-4">{faq.question}</span>
                <ChevronDown className={`h-4 w-4 text-[#a8abb3] transition-transform flex-shrink-0 ${expandedFaq === index ? 'rotate-180' : ''}`} />
              </button>
              {expandedFaq === index && (
                <div className="px-6 pb-5 pt-0">
                  <p className="text-[#a8abb3] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
